/* Kollektionsside: filtre indsendes automatisk, drawer på mobil. */
(function () {
  'use strict';
  var filtre = document.querySelector('[data-hh-filtre]');
  var overlay = document.querySelector('[data-hh-filtre-overlay]');
  var desktop = window.matchMedia('(min-width: 990px)');

  var sektion = document.querySelector('[data-hh-sektion]');
  var sektionId = sektion ? sektion.getAttribute('data-hh-sektion') : null;
  var henter = false;

  /* ---------- Hent kun det, der aendrer sig ----------
     I stedet for at genindlaese hele siden henter vi sektionen igen via
     Shopifys Section Rendering API og bytter resultatspalten og filtrene ud.
     Adressen skrives om med history.pushState, saa frem/tilbage og deling
     stadig virker. Uden JavaScript er alting almindelige links og en
     almindelig formular — siden virker praecis som foer. */
  function skiftIndhold(url, tilfoej) {
    if (!sektionId || henter) return false;
    henter = true;

    var resultat = document.querySelector('.hh-kol__resultat');
    if (resultat) { resultat.classList.add('er-henter'); resultat.setAttribute('aria-busy', 'true'); }

    var u = new URL(url, window.location.origin);
    var hent = new URL(u.toString());
    hent.searchParams.set('section_id', sektionId);

    return fetch(hent.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nytResultat = doc.querySelector('.hh-kol__resultat');
        if (!nytResultat) throw new Error('intet resultat');

        if (tilfoej) {
          /* "Vis flere": laeg varerne i forlaengelse i stedet for at erstatte */
          var gitter = document.querySelector('.hh-gitter');
          var nytGitter = nytResultat.querySelector('.hh-gitter');
          if (gitter && nytGitter) {
            while (nytGitter.firstElementChild) gitter.appendChild(nytGitter.firstElementChild);
          }
          var mere = document.querySelector('.hh-kol__mere');
          var nyMere = nytResultat.querySelector('.hh-kol__mere');
          if (mere) { if (nyMere) mere.replaceWith(nyMere); else mere.remove(); }
          var taeller = document.querySelector('.hh-kol__taeller');
          var nyTaeller = nytResultat.querySelector('.hh-kol__taeller');
          if (taeller && nyTaeller) taeller.textContent = nyTaeller.textContent;
        } else {
          if (resultat) resultat.replaceWith(nytResultat);
          var nyeFiltre = doc.querySelector('.hh-filtre');
          var gamleFiltre = document.querySelector('.hh-filtre');
          if (nyeFiltre && gamleFiltre) {
            var varAaben = gamleFiltre.classList.contains('is-aaben');
            gamleFiltre.replaceWith(nyeFiltre);
            if (varAaben) nyeFiltre.classList.add('is-aaben');
            filtre = nyeFiltre;
          }
          var nytSegment = doc.querySelector('.hh-kol__segment');
          var gammeltSegment = document.querySelector('.hh-kol__segment');
          if (nytSegment && gammeltSegment) gammeltSegment.replaceWith(nytSegment);
          byggSorter(document.querySelector('[data-hh-sorter]'));
        byggTaethed();
        byggPrisSkyder();
        document.dispatchEvent(new CustomEvent('hh:nytindhold', { detail: { rod: document } }));
        }

        u.searchParams.delete('section_id');
        window.history.pushState({ hh: true }, '', u.pathname + u.search);
      })
      .catch(function () { window.location.href = url; })
      .finally(function () {
        henter = false;
        var r2 = document.querySelector('.hh-kol__resultat');
        if (r2) { r2.classList.remove('er-henter'); r2.removeAttribute('aria-busy'); }
      });
  }

  function send() {
    var f = document.getElementById('hh-filter-form');
    if (!f) return;
    var params = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (v !== '') params.append(k, v); });
    var maal = window.location.pathname + '?' + params.toString();
    if (!skiftIndhold(maal)) window.location.search = params.toString();
  }

  /* ---------- Filter-drawer paa mobil ----------
     Alt er delegeret, fordi baade filterknappen, luk-knapperne og selve
     spalten bliver byttet ud, naar indholdet hentes paa ny. */
  function saetAaben(v) {
    filtre = document.querySelector('[data-hh-filtre]');
    if (!filtre) return;
    filtre.classList.toggle('is-aaben', v);
    if (overlay) { overlay.hidden = false; overlay.classList.toggle('is-aaben', v); }
    var knap = document.querySelector('[data-hh-filtre-aabn]');
    if (knap) knap.setAttribute('aria-expanded', v ? 'true' : 'false');
    document.documentElement.style.overflow = v ? 'hidden' : '';
  }

  function luk() {
    saetAaben(false);
    var f = document.getElementById('hh-filter-form');
    if (f && f.dataset.aendret === '1') { delete f.dataset.aendret; send(); }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-hh-filtre-aabn]')) { e.preventDefault(); saetAaben(true); return; }
    if (e.target.closest('[data-hh-filtre-luk]')) { e.preventDefault(); luk(); }
  });
  if (overlay) overlay.addEventListener('click', luk);
  document.addEventListener('keydown', function (e) {
    var f = document.querySelector('[data-hh-filtre]');
    if (e.key === 'Escape' && f && f.classList.contains('is-aaben')) luk();
  });

  /* Delegeret, saa det ogsaa virker efter at filtrene er byttet ud */
  document.addEventListener('change', function (e) {
    if (e.target.closest('#hh-filter-form')) {
      var f = document.getElementById('hh-filter-form');
      if (desktop.matches) send();
      else if (f) f.dataset.aendret = '1';
    }
  });

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a');
    if (!a || !sektionId) return;
    if (a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;

    var indeni = a.closest('.hh-kol__segment,.hh-kol__aktive,.hh-kol__mere,.hh-filtre__bund');
    if (!indeni) return;

    var maal = new URL(a.href, window.location.origin);
    if (maal.pathname !== window.location.pathname) return;

    e.preventDefault();
    skiftIndhold(a.href, a.closest('.hh-kol__mere') !== null);
  });

  /* ---------- Skift til en ANDEN kollektion uden sideskift ----------
     Chips til underkollektioner foerer til en anden side, hvor ogsaa hero,
     overskrift og broedkrumme skifter. Derfor byttes hele sektionen ud — ikke
     kun gitteret — og sidens titel foelger med. Fejler noget, falder vi
     tilbage til et almindeligt klik. */
  function skiftSektion(url) {
    if (henter) return false;
    var vaert = document.querySelector('[data-hh-sektion]');
    if (!vaert) return false;
    henter = true;

    /* Hvor stod chip-raekken paa skaermen? Efter skiftet laegger vi den samme
       sted, saa man kan klikke videre uden at siden hopper til toppen. */
    var anker = document.querySelector('.hh-maerke__kat');
    var ankerY = anker ? anker.getBoundingClientRect().top : null;
    vaert.classList.add('er-henter');
    vaert.setAttribute('aria-busy', 'true');

    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ny = doc.querySelector('[data-hh-sektion]');
        if (!ny) throw new Error('ingen sektion');
        vaert.replaceWith(ny);
        sektion = ny;
        sektionId = ny.getAttribute('data-hh-sektion');
        filtre = document.querySelector('[data-hh-filtre]');
        if (doc.title) document.title = doc.title;
        byggSorter(document.querySelector('[data-hh-sorter]'));
        byggTaethed();
        byggPrisSkyder();
        document.dispatchEvent(new CustomEvent('hh:nytindhold', { detail: { rod: document } }));
        window.history.pushState({ hh: true }, '', url);

        var nytAnker = document.querySelector('.hh-maerke__kat');
        if (ankerY !== null && nytAnker) {
          var maalY = nytAnker.getBoundingClientRect().top + window.scrollY - ankerY;
          var maks = document.documentElement.scrollHeight - window.innerHeight;
          window.scrollTo({ top: Math.max(0, Math.min(maalY, maks)), behavior: 'instant' });
        } else {
          window.scrollTo({ top: 0, behavior: 'instant' });
        }
      })
      .catch(function () { window.location.href = url; })
      .finally(function () {
        henter = false;
        var v = document.querySelector('[data-hh-sektion]');
        if (v) { v.classList.remove('er-henter'); v.removeAttribute('aria-busy'); }
      });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.hh-maerke__kat a, .hh-kol__under a, .hh-crumbs a');
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var maal = new URL(a.href, window.location.origin);
    /* Kun kollektionssider — forsiden og andre skabeloner skal loades normalt */
    if (maal.origin !== window.location.origin) return;
    if (maal.pathname.indexOf('/collections/') !== 0) return;
    e.preventDefault();
    skiftSektion(maal.toString());
  });

  window.addEventListener('popstate', function () {
    if (!sektionId) return;
    var v = document.querySelector('[data-hh-sektion]');
    /* Er vi havnet paa en anden kollektion, skal hele sektionen hentes */
    if (v && v.dataset.hhSti && v.dataset.hhSti !== window.location.pathname) {
      skiftSektion(window.location.href);
      return;
    }
    var u = new URL(window.location.href);
    u.searchParams.set('section_id', sektionId);
    fetch(u.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nyt = doc.querySelector('.hh-kol__resultat');
        var gl = document.querySelector('.hh-kol__resultat');
        if (nyt && gl) gl.replaceWith(nyt);
        var nf = doc.querySelector('.hh-filtre'), gf = document.querySelector('.hh-filtre');
        if (nf && gf) gf.replaceWith(nf);
        var ns = doc.querySelector('.hh-kol__segment'), gs = document.querySelector('.hh-kol__segment');
        if (ns && gs) gs.replaceWith(ns);
        byggSorter(document.querySelector('[data-hh-sorter]'));
        byggTaethed();
        byggPrisSkyder();
        document.dispatchEvent(new CustomEvent('hh:nytindhold', { detail: { rod: document } }));
      })
      .catch(function () { window.location.reload(); });
  });

  /* Chips til ANDRE kollektioner er rigtige sideskift — men vi henter siden
     ned paa forhaand, naar musen rammer dem, saa den foeles oejeblikkelig. */
  var forhentet = {};
  document.addEventListener('mouseover', function (e) {
    var a = e.target.closest('.hh-maerke__kat a, .hh-kol__under a, .hh-soegeside__kat a');
    if (!a || forhentet[a.href]) return;
    forhentet[a.href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.href = a.href; l.as = 'document';
    document.head.appendChild(l);
  }, { passive: true });

  document.addEventListener('change', function (e) {
    var v = e.target.closest('[data-hh-sorter]');
    if (!v) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', v.value);
    u.searchParams.delete('page');
    if (!skiftIndhold(u.toString())) window.location.href = u.toString();
  });

  /* ---------- Egen sorteringsmenu ----------
     Browserens <select>-menu kan ikke styles — den bruger systemets farver og
     ligner ikke resten. Vi bygger en egen og lader <select> blive i DOM'en som
     kilde, saa siden ogsaa virker uden JavaScript. */
  function byggSorter(vaelg) {
    if (!vaelg) return;
    var pakke = vaelg.closest('.hh-kol__sorter');
    if (!pakke || pakke.classList.contains('har-js')) return;
    pakke.classList.add('har-js');

    var muligheder = Array.prototype.slice.call(vaelg.options);
    var knap = document.createElement('button');
    knap.type = 'button';
    knap.className = 'hh-sorter__knap';
    knap.setAttribute('aria-haspopup', 'listbox');
    knap.setAttribute('aria-expanded', 'false');
    knap.innerHTML = '<span class="hh-sorter__label">Sortér</span>' +
      '<span data-hh-sorter-navn></span>' +
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" aria-hidden="true">' +
      '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var liste = document.createElement('ul');
    liste.className = 'hh-sorter__liste';
    liste.setAttribute('role', 'listbox');
    liste.setAttribute('aria-label', 'Sortér efter');
    liste.hidden = true;

    muligheder.forEach(function (o, i) {
      var li = document.createElement('li');
      li.className = 'hh-sorter__valg';
      li.setAttribute('role', 'option');
      li.setAttribute('tabindex', '-1');
      li.dataset.vaerdi = o.value;
      li.id = 'hh-sort-' + i;
      li.setAttribute('aria-selected', o.selected ? 'true' : 'false');
      li.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">' +
        '<path d="M5 12.5l4.5 4.5L19 7" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '<span></span>';
      li.querySelector('span').textContent = o.textContent;
      liste.appendChild(li);
    });

    knap.querySelector('[data-hh-sorter-navn]').textContent =
      vaelg.options[vaelg.selectedIndex] ? vaelg.options[vaelg.selectedIndex].textContent : '';

    pakke.appendChild(knap);
    pakke.appendChild(liste);

    var valg = Array.prototype.slice.call(liste.children);
    var aaben = false;

    function saetAaben(v) {
      aaben = v;
      liste.hidden = !v;
      knap.setAttribute('aria-expanded', v ? 'true' : 'false');
      pakke.classList.toggle('er-aaben', v);
      if (v) {
        var valgt = valg.filter(function (l) { return l.getAttribute('aria-selected') === 'true'; })[0] || valg[0];
        if (valgt) valgt.focus();
      }
    }

    function vaelgIndeks(i) {
      var li = valg[i];
      if (!li) return;
      vaelg.value = li.dataset.vaerdi;
      saetAaben(false);
      knap.focus();
      vaelg.dispatchEvent(new Event('change', { bubbles: true }));
    }

    knap.addEventListener('click', function () { saetAaben(!aaben); });

    liste.addEventListener('click', function (e) {
      var li = e.target.closest('.hh-sorter__valg');
      if (li) vaelgIndeks(valg.indexOf(li));
    });

    liste.addEventListener('keydown', function (e) {
      var nu = valg.indexOf(document.activeElement);
      if (e.key === 'ArrowDown') { e.preventDefault(); (valg[nu + 1] || valg[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); (valg[nu - 1] || valg[valg.length - 1]).focus(); }
      else if (e.key === 'Home') { e.preventDefault(); valg[0].focus(); }
      else if (e.key === 'End') { e.preventDefault(); valg[valg.length - 1].focus(); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); vaelgIndeks(nu); }
      else if (e.key === 'Escape') { e.preventDefault(); saetAaben(false); knap.focus(); }
      else if (e.key === 'Tab') { saetAaben(false); }
    });

    document.addEventListener('click', function (e) {
      if (aaben && !pakke.contains(e.target)) saetAaben(false);
    });
  }


  /* --- Taethed: 4 eller 3 kort pr. raekke --------------------------------
     Valget gemmes lokalt, saa det holder mellem sider. Knapperne findes kun,
     naar JS koerer — uden JS kan de ikke goere noget. */
  var TAETHED_NOEGLE = 'hh-taethed';

  function laesTaethed() {
    try { return localStorage.getItem(TAETHED_NOEGLE) === '3' ? '3' : '4'; }
    catch (e) { return '4'; }
  }

  function saetTaethed(v, pakke) {
    var gitter = document.querySelector('.hh-kol__resultat .hh-gitter');
    if (gitter) gitter.classList.toggle('hh-gitter--3', v === '3');
    if (pakke) {
      [].forEach.call(pakke.querySelectorAll('[data-hh-kol]'), function (b) {
        b.setAttribute('aria-pressed', b.dataset.hhKol === v ? 'true' : 'false');
      });
    }
  }

  function byggTaethed() {
    var pakke = document.querySelector('[data-hh-taethed]');
    if (!pakke) return;
    pakke.classList.add('har-js');
    saetTaethed(laesTaethed(), pakke);
    if (pakke.dataset.hhKlar) return;
    pakke.dataset.hhKlar = '1';
    pakke.addEventListener('click', function (e) {
      var b = e.target.closest('[data-hh-kol]');
      if (!b) return;
      var v = b.dataset.hhKol;
      try { localStorage.setItem(TAETHED_NOEGLE, v); } catch (err) {}
      saetTaethed(v, pakke);
    });
  }


  /* --- Pris-skyder ------------------------------------------------------
     To haandtag. Talfelterne under er dem, der sendes til Shopify —
     skyderne skriver bare i dem. */
  var kr = function (n) {
    try { return Number(n).toLocaleString('da-DK'); } catch (e) { return String(n); }
  };

  function byggPrisSkyder() {
    document.querySelectorAll('[data-hh-skyder]').forEach(function (boks) {
      if (boks.dataset.hhKlar) return;
      boks.dataset.hhKlar = '1';
      boks.classList.add('har-js');

      var lav = boks.querySelector('[data-hh-skyder-fra]');
      var hoj = boks.querySelector('[data-hh-skyder-til]');
      var gruppe = boks.closest('.hh-filtre__gruppe');
      var mrk = gruppe && gruppe.querySelector('[data-hh-pris-label]');
      var maksMrk = boks.querySelector('[data-hh-pris-maks]');
      var feltFra = boks.parentElement.querySelector('[data-hh-pris-fra]');
      var feltTil = boks.parentElement.querySelector('[data-hh-pris-til]');
      var maks = parseFloat(boks.dataset.max) || 0;
      if (!lav || !hoj || !maks) return;

      if (maksMrk) maksMrk.textContent = kr(maks) + ' kr';

      function tegn() {
        boks.style.setProperty('--fra', lav.value);
        boks.style.setProperty('--til', hoj.value);
        if (!mrk) return;
        var a = parseFloat(lav.value), b = parseFloat(hoj.value);
        if (a <= 0 && b >= maks) mrk.textContent = 'alle priser';
        else if (a <= 0) mrk.textContent = 'op til ' + kr(b) + ' kr';
        else if (b >= maks) mrk.textContent = 'fra ' + kr(a) + ' kr';
        else mrk.textContent = kr(a) + '–' + kr(b) + ' kr';
      }

      /* Haandtagene maa ikke passere hinanden */
      function ryd(hvem) {
        var a = parseFloat(lav.value), b = parseFloat(hoj.value);
        if (a > b) { if (hvem === 'lav') lav.value = b; else hoj.value = a; }
      }

      function skriv() {
        /* Tomt felt = ingen graense, saa Shopify ikke faar 0 og maks med */
        if (feltFra) feltFra.value = parseFloat(lav.value) > 0 ? lav.value : '';
        if (feltTil) feltTil.value = parseFloat(hoj.value) < maks ? hoj.value : '';
      }

      lav.addEventListener('input', function () { ryd('lav'); tegn(); skriv(); });
      hoj.addEventListener('input', function () { ryd('hoj'); tegn(); skriv(); });

      /* Det oeverste haandtag skal kunne gribes, ogsaa naar de staar oven i
         hinanden: den, man er taettest paa, laegges oeverst. */
      boks.addEventListener('pointerdown', function (e) {
        var b = boks.querySelector('.hh-filtre__bane').getBoundingClientRect();
        var pct = (e.clientX - b.left) / b.width * maks;
        var naermestLav = Math.abs(pct - lav.value) <= Math.abs(pct - hoj.value);
        lav.style.zIndex = naermestLav ? 3 : 2;
        hoj.style.zIndex = naermestLav ? 2 : 3;
      });

      /* Skyderne ligger i #hh-filter-form, saa deres native change-event
         bobler op til den delegerede lytter og henter selv. */
      tegn();
    });
  }

  byggSorter(document.querySelector('[data-hh-sorter]'));
  byggTaethed();
  byggPrisSkyder();
        byggPrisSkyder();
        document.dispatchEvent(new CustomEvent('hh:nytindhold', { detail: { rod: document } }));
})();

/* Videoflise i gitteret: hentes først efter sidens load-hændelse og kun når
   flisen er (næsten) synlig, så den ikke konkurrerer med varebillederne.
   Ved "reducer bevægelse" eller datasparetilstand vises kun plakatbilledet. */
(function () {
  var videoer = document.querySelectorAll('[data-hh-flisevideo]');
  if (!videoer.length) return;
  var spar = navigator.connection && navigator.connection.saveData;
  var rolig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (spar || rolig) return;
  function start(v) {
    if (v.dataset.hhStartet) return;
    v.dataset.hhStartet = '1';
    var fuld = v.dataset.src;
    var mindre = (window.innerWidth < 750 ? v.dataset.lille : v.dataset.mellem) || v.dataset.mellem || fuld;
    if (mindre !== fuld) v.addEventListener('error', function fejl() { v.removeEventListener('error', fejl); v.src = fuld; v.play().catch(function () {}); });
    v.src = mindre;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function klar() {
    if (!('IntersectionObserver' in window)) { videoer.forEach(start); return; }
    var io = new IntersectionObserver(function (poster) {
      poster.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) { start(v); if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } }
        else if (v.dataset.hhStartet) { v.pause(); }
      });
    }, { rootMargin: '200px 0px' });
    videoer.forEach(function (v) { io.observe(v); });
  }
  if (document.readyState === 'complete') klar(); else window.addEventListener('load', klar, { once: true });
})();
